<template>
  <div>
    <AddressInput :inputField="address" inputName="Business Address" inputType="string" @selectedAddress="updateAddress"/>
    <Input :inputField="city" inputName="City" inputType="string"/>
    <Input :inputField="state" inputName="State" inputType="string"/>
    <Input :inputField="zip" inputName="Zip Code" inputType="string"/>
    <div class="buttons is-right">
      <a class="button is-link padded-button next-button" @click="next">Next</a>
    </div>
  </div>
</template>

<script>
import Input from '@/components/shared/Input'
import AddressInput from '@/components/shared/AddressInput'
export default {
  name: 'BusinessAddress',
  components: {
    Input,
    AddressInput
  },
  data () {
    return {
      address: AddressInput.model(),
      city: Input.model(),
      state: Input.model(),
      zip: Input.model()
    }
  },
  methods: {
    next () {
      this.$emit('next', this.$data)
      console.log(this.$data)
    },
    updateAddress (obj) {
      this.city.value = obj.city
      this.state.value = obj.state
      this.zip.value = obj.zip
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
